import { CalendarToday } from '@mui/icons-material'
import { JSX } from 'react'

const CalendarTodayIcon = (): JSX.Element => <CalendarToday />

export default CalendarTodayIcon
